export const appendDirLocal = '' // Use 'nestforms/' on localhost
export const googleApiKey = 'AIzaSyCkupbjebqozDp69YEyLIdj48hDqpE2J8Q'
export const googleAnalyticsTagManagerId = 'G-D2CZGL3L11' // G-tag
export const tinyApiKey = 'qzy19kdfqnc3224qz1vz3kn3gtrhz7imutocz0hrjnoir614'
export const websocketUrl = 'wss://www.nestforms.com/ws-notifier/' // production: wss://www.nestforms.com/ws-notifier/, development: ws://localhost:3002

